<template>

	<div class="row">
		<div class="col-md-6 col-md-offset-3 col-sm-12">
			<h3 class="page-header">409: Account Inactive</h3>
            <div class="card">
                <div class="card-body">
                    Your account has been deactivate. To reactive your account, contact a system administrator:
                    <ul>
                        <li v-for="user in admins">
                            <a :href="`mailto:${user.email}`">{{ user.FirstName }} {{ user.LastName }}</a>
                        </li>
                    </ul>
                </div>
            </div>
    	</div>
    </div>
</template>

<script>
    export default {
    	data: function() {
            return {
                admins: [],
            }
        },

        methods: {
            //Load admins

        },

        mounted() {
            //Load the admins?
        }
    }
</script>
